import { jwtDecode } from 'jwt-decode';

let logoutTimer = null;

var timeOut = (exp, logoutfunction) => {
  if (logoutTimer) {
    clearTimeout(logoutTimer);
  }

  let currentDate = new Date();
  const remainingMs = exp * 1000 - currentDate.getTime() - 360000;
  const delay = remainingMs > 0 ? remainingMs : 0;
  logoutTimer = setTimeout(logoutfunction, delay);

  return () => {
    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }
  };
};

const checkValidToken = (logoutfunction, token) => {
  let currentDate = new Date();
  try {
    if (token) {
      let decodedToken = jwtDecode(token);
      const time = decodedToken.exp * 1000 > currentDate.getTime();
      if (time) {
        timeOut(decodedToken.exp, logoutfunction);
      }
      return time;
    }
    return false;
  } catch (err) {
    return false;
  }
};

const checkvalidEmbedToken = (token) => {
  let currentDate = new Date();
  try {
    if (token) {
      let decodedToken = jwtDecode(token);
      const time = decodedToken.exp * 1000 > currentDate.getTime();
      return time;
    }
    return false;
  } catch (err) {
    return false;
  }
};

// Only one embed-token refresh timer may be pending. Without this, every
// token fetch armed another timer, and an old timer could later refresh with a
// previous user's details (e.g. after an admin switched impersonation).
let embedRefreshTimer = null;

var embedReportTimeOut = (exp, refreshFunction) => {
  let currentDate = new Date();
  if (embedRefreshTimer) {
    clearTimeout(embedRefreshTimer);
  }
  let timeout = setTimeout(
    refreshFunction,
    Math.max(parseInt(exp * 1000 - currentDate.getTime() - 300000), 0),
  );
  embedRefreshTimer = timeout;
  return () => {
    //Clearing a timeout
    clearTimeout(timeout);
  };
};

const reportEmbedTokenRefresh = (refreshFunction, token) => {
  let currentDate = new Date();
  try {
    if (token) {
      let decodedToken = jwtDecode(token);
      const time = decodedToken.exp * 1000 > currentDate.getTime();
      embedReportTimeOut(decodedToken.exp, refreshFunction);
      return time;
    }
    return false;
  } catch (err) {
    return false;
  }
};
export default checkValidToken;
export { checkvalidEmbedToken, reportEmbedTokenRefresh };
